<template>
  <div id="PriceFunFood">
    <div data-html2canvas-ignore="true" class="customdim" v-show="loader">
      <div class="spinner-border" role="status"><span class="sr-only">Loading...</span></div>
    </div>
    <div class="datepickerwrap" style="padding-right:0">
  		<div class="leftcontent wrapitem">
  			<div class="datebox" >
  	 		  <datepicker :disabled="timestamp1Disabled" @input="refresh" v-model="timestamp" />
  	 		</div>
  			<div class="datebox" >
  	 		  <datepicker :disabled="timestamp2Disabled" @input="refresh" v-model="timestamp2" />
  	 		</div>
  			<div class="datebox" >
  	 		  <select @change="getPriceData" v-model="selectedCat" class="form-control text-uppercase">
            <option v-for="d in catOptions" :value="d" :key="d">{{ d.replace('_',' ') }}</option>
          </select>
  	 		</div>
  			<div class="datebox">
  	 		  <select @change="getPriceData" v-model="selectedPlatform" class="form-control text-uppercase">
            <option value=''>All</option>
            <option v-for="(d,i) in platformColor" :value="i" :key="i">{{ i }}</option>
          </select>
  	 		</div>
  		</div>   
      <div class="righcontent wrapitem">   
  			<div class="datebox float-right">
  	 		    <input class="form-control" type="text" @keyup="searchProduct" v-model="schKey" placeholder="Search" > 
  	 		</div>
  		</div>
    </div>
    <div class="container-fluid" >
      <div class="productwrap"> 
        <b-row style="background: whitesmoke;;margin-bottom: 25px;" v-for="(od,oi) in data" :key="'product_price_'+oi"  >
          <b-col  sm="12" lg="12">
            <b-row>
              <div :class="{'col-sm-4':od.length==3,'col-sm-6':od.length==2,'col-sm-12':od.length==1}"  v-for="(pd,pi) in od" :key="'compTimelines_' + oi + '_' + pd.product_name + '_'+pi" >
                <h5 :title="pd.product_name" class="cust-head" style="font-size:13px;margin-top: 9px;color:#533a79!important;text-transform:capitalize;">
                  {{pd.product_name.toUpperCase()}}
                </h5>
                <b-card style="border:none;padding: 2px;margin-bottom: 9px;">
                  <div style="width:100%;" :class="{'chartOverflow':od.length>1}">
                    <highcharts :style="getChartWidth(od.length)" :options="chartData['compChart_' + oi + '_' + pd.product_name + '_'+pi]" ></highcharts>
                  </div>
                </b-card>
              </div>
            </b-row>
            <b-row style="padding-left: 9px;padding-right: 9px;margin-bottom: 8px;" v-for="(pd,pi) in od" :key="'compSummary_' + oi + '_' + pd.product_name + '_'+pi">
              <div class="col-sm-12" style="padding-right:6px;padding-left:6px">
                <h5 class="cust-head" style="font-size:13px;margin-top: 9px;color:#533a79!important;text-transform:capitalize;">{{pd.product_name.toUpperCase() }}</h5>
              </div>  
              <b-col :class="{'col-sm-2':selectedPlatform}" style="padding-right:6px;padding-left:6px"  v-for="d in pd.platform_data" :key="d.platform+oi">
                <b-card style="border:none;" :class="d.platform + '_border'" >
                  <div class="rightsticker">
                    <div class="name">
                      <img style="width:19px" :src="'/img/' + d.platform +'.png'">
                      <a v-if="d.link" target="_blank" :href="d.link"> {{ d.platform }} </a>
                      <span v-else > {{ d.platform }} </span>
                    </div>
                    <div class="value" :style="'color:'+ platformColor[d.platform ]">
                      <i class="fa fa-rupee" v-if="(d.discount_price && d.discount_price!='N/A' && d.link) || (d.original_price && d.original_price!='N/A') " ></i> 
                      <span v-if="d.discount_price"> {{ formatNumber(d.discount_price) }}</span>
                      <span v-if="!d.discount_price && d.original_price "> {{ formatNumber(d.original_price) }}</span>
                      <span v-if="d.quantity"> ({{ d.quantity }})</span>
                      <div class="outofstock" v-if="d.not_available">Not Available</div>
                      <div class="outofstock" v-if="!d.not_available && d.out_of_stock">Out of stock</div>
                    </div>
                  </div>  
                </b-card>
              </b-col>  
            </b-row>
          </b-col>
        </b-row>  
      </div>  
    </div>
  </div>
</template>

<script> 
import moment from 'moment'
import Datepicker from 'vuejs-datepicker'

export default {
  name: 'PriceFunFood',
  components: {
    Datepicker
  },
  data: function () {
    return {
      data: {},
      moment:moment,
      seriesDataFiltered: [],
      timestamp: moment('2022-03-01').subtract(4,'days').format('YYYY-MM-DD'),
      timestamp2: moment('2022-03-01').format('YYYY-MM-DD'),
      // timestamp2: moment().add(1,'days').format('YYYY-MM-DD'),
      timestamp1Disabled: {
        to: '',
        from: ''
      },
      timestamp2Disabled: {
        to: '',
        from: ''
      },
      catOptions: [],
      loader: false,
      selectedCat: '',
      schKey: '',
      dataFull: {},
      chartData: [],
      selectedPlatform: '',
      platformColor: {
        amazon: '#FF9900',
        croma: '#49a7a1',
        flipkart: '#2874f0',
        myntra: '#ec548b',
        paytm: '#28bbf0',
        ril: '#bfa161',
        snapdeal: '#f34741',
        tatacliq: '#c14553',
        vijaysales: '#ee4326'
      }
    }
  },
  mounted()
  {
    this.refresh()
  },
  methods: {
    updateDisabledDates(){
      this.timestamp1Disabled= {
        to: moment('2021-07-26','YYYY-MM-DD').toDate(),
        from: moment(this.timestamp2,'YYYY-MM-DD').toDate()
      }
      this.timestamp2Disabled= {
        to: moment(this.timestamp,'YYYY-MM-DD').toDate(),
        from: moment('2022-03-01').toDate()
      }
    },
    getChartWidth(compCount){
      if (compCount==1)  return 'width:100%'
      let diff = moment(this.timestamp2).diff(moment(this.timestamp), 'days')
      if (diff<4)  return 'width:100%'
      let width = diff * 100
      return 'width:'+width + 'px'
    },
    formatNumber(n){
      if(n && !isNaN(n))
      {
        return Number(n).toLocaleString()
      }  
      else
      {
        return n  
      }  
    },
    searchProduct(){
      let self = this
      this.loader = true

      setTimeout(function(){
        self.data = {}
        for (let [idx, ds] of Object.entries(self.dataFull))
        {
          if(idx.toLowerCase().includes(self.schKey.toLowerCase()))
          {
            self.data[idx] = ds
          }
        }
        self.loader = false
      },0)
    },
    processChart(){
      let self = this
      for (let [idx, ds] of Object.entries(this.data))
      {
        for (let [idx2, ds2] of ds.entries())
        {
          let chartKey = 'compChart_'+ idx + '_' + ds2.product_name + '_' + idx2
          self.createChart(ds2.timeline,chartKey)
        }
      }
    },
    removeEmptySeries(){
      let self = this
      for(let [i,d] of self.seriesDataFiltered.entries())
      {
        var hasData = false
        for(let [idx,ds] of d.data.entries())
        {
          if(ds.toString().length)
          {
            hasData = true
          }  
        }
        if(!hasData)
        {
          self.seriesDataFiltered.splice(i,1)
          this.removeEmptySeries()
        }
        if(i==self.seriesDataFiltered.length-1) return 
      }

    },
    createChart(timeline,key){
      let self = this
      let xaxis = []
      self.seriesDataFiltered = []
      let seriesData = []
      for (let [idx, ds] of timeline.entries())
      {
        xaxis.push(moment(ds.date).format('DD MMM YYYY'))
        for (let [idx2, ds2] of ds.price.entries())
        {
          if(idx == 0)
          { 
            seriesData.push({name: ds2.name.toUpperCase(),data: [ds2.value], color: self.platformColor[ds2.name] })
          }
          else
          {
            for (let [idx3, ds3] of seriesData.entries()) if(ds3.name == ds2.name.toUpperCase() ) ds3.data.push(ds2.value)
          }
        }
      }
      if(self.selectedPlatform)
      {
        for (let [idx2, ds2] of seriesData.entries())
        {
          if(self.selectedPlatform.toUpperCase() == ds2.name)
          {
            self.seriesDataFiltered.push(ds2)
          }
        }
      }
      else
      {
        self.seriesDataFiltered = seriesData
      }
      this.removeEmptySeries()
      let obj = {}
      self.chartData[key] = {
        chart: {
            type: 'line',
            height:200
        },
        title: {
            text: ''
        },
        subtitle: {
            verticalAlign:'bottom',
            text: ''
        },
        xAxis: {
          tickmarkPlacement: 'on',
          categories: xaxis,
          title: { text: '' },
          gridLineWidth:1,
          labels: {
            rotation:0,
            style:{fontSize:10,textOverflow: 'none'},
          }
        },
        plotOptions: {
          line: {
            marker: {
              radius: 3
            },
            dataLabels: {
              enabled: true,
              allowOverlap:true,
              style:{fontWeight:0},
              formatter:function(){ 
                return '₹' + this.point.y.toLocaleString() 
              },
            }
          },
        },
        yAxis: {
            title: {
                text: 'Price(₹)',
            },
        },
        tooltip: {
          formatter: function() {
              var mytooltip = this.points[0].key + '<br/>' ;
              for(var i = 0;i<this.points.length;i++)
              { 
                mytooltip += '<span style="color:'+ this.points[i].color + '">● </span>' 
                mytooltip += this.points[i].series.name
                mytooltip += ':<b> ₹' + self.formatNumber(this.points[i].y) + '</b><br/>' ; 
              }
              return mytooltip;
            },
          shared:true
        },
        legend: {
            align: 'left',
            enabled:true
        },
        credits: {
            enabled: false
        },
        series: self.seriesDataFiltered
      }
    },
    getPriceData(){
      let self = this
      let url = "/api/india_clients/product_price"
      this.loader = true
      this.data = {}
      this.dataFull = {}
      let payload = {
        "start_date": moment(this.timestamp).format('YYYY-MM-DD'),
        "end_date": moment(this.timestamp2).format('YYYY-MM-DD'),
        "item_category": this.selectedCat,
        "client": "philips"
      }
      this.$http.post(url,payload).then(response => {
        this.loader = false
        for (let [idx, ds] of Object.entries(response.data.data))
        {
          if (self.selectedPlatform){
            for (let [idx2, ds2] of  ds.entries())
            {  
              for (let [i, d] of  ds2.platform_data.entries())
              {
                if(d.platform == self.selectedPlatform)
                { 
                  ds2.platform_data = [d]
                }
              }
            }  
          }
          this.data[idx] = ds 
          this.dataFull[idx] = ds 
        }
        this.processChart()
      }, err => {
        this.loader = false
      });
    },
    getCat(){
      let url = "/api/india_clients/product_price_categories"
      this.loader = true
      let payload = {
        "start_date": moment(this.timestamp).format('YYYY-MM-DD'),
        "end_date": moment(this.timestamp).format('YYYY-MM-DD'),
        "client": "philips"
      }
      this.$http.post(url,payload).then(response => {
        this.loader = false
        this.catOptions = response.data.data
        this.selectedCat = this.catOptions[0]
        this.getPriceData()
    
      }, err => {
        this.loader = false
      });

    },
    refresh(){
      this.updateDisabledDates()
      this.getCat()
    },
  }
}
</script>
<style scoped>
  .chartOverflow {
    
    overflow-x: scroll;
  }
 .name
 {
    line-height: 28px;
    text-transform: capitalize;
    font-size: 14px;
    margin-left: 5px;
 }
 .value
 {
    font-size: 14px;
    line-height: 24px;
    margin-left: 5px;
 }
 .leftsticker
 {
    width: 65px;
    float: left;
    height: 54px;
    color: white;
    font-size: 37px;
    text-align: center;
 }
 .rightsticker
 {
    width: 100%;
    float: left;
    background:white;
 }
 .card
 {
   margin-bottom:8px
 }
 .card-body
 {
  padding:0!important;
  display:flex;
 }
 .productwrap
 {

    padding: 26px;
    padding-top:6px;
    margin-top: 6px;
 }
 
 .grofers_border
 {
  border-right: 2px solid #f15c2c!important;
 }
 .tatacliq_border
 {
  border-right: 2px solid #a9323f!important;
 }
 .bigbasket_border
 {
   border-right: 2px solid #83c42a!important;
 }
 .tatacliq_border
 {
   border-right: 2px solid #a9323f!important;
 }
 
 .amazon_border
 {
  border-right: 2px solid #FF9900!important;
 }

 .croma_border
 {
  border-right: 2px solid #49a7a1!important;
 }

 .paytm_border
 {
  border-right: 2px solid #28bbf0!important;
 }

 .snapdeal_border
 {
  border-right: 2px solid #f34741!important;
 }

 .myntra_border
 {
  border-right: 2px solid #ec548b!important;
 }
 
 .vijaysales_border
 {
  border-right: 2px solid #ee4326!important;
 }
 .ril_border
 {
  border-right: 2px solid #bfa161!important;
 }
 .outofstock
 {
    color:red;
    float:right;
    font-size:12px;
    margin-right:5px
 }
 .flipkart_border
 {
  border-right: 2px solid #2874f0!important;
 }

</style>